import { combineReducers } from 'redux';
import Users from '../views/Users/redux/UsersReducers';
import Clients from '../views/Clients/redux/ClientsReducers';
import Franchises from '../views/Franchises/redux/FranchisesReducers';
import Hotels from '../views/Hotels/redux/HotelsReducers';
import BillingInformationFranchises from '../views/BillingInformationFranchises/redux/BillingInformationFranchisesReducers';
import BillingInformationClients from '../views/BillingInformationClients/redux/BillingInformationClientsReducers';
import Quotations from '../views/Quotations/redux/QuotationsReducers';
import Receipts from '../views/Receipts/redux/ReceiptsReducers';
import OperatorPayments from '../views/OperatorPayments/redux/OperatorPaymentsReducers';
import Comissions from '../views/Comissions/redux/ComissionsReducers';
import Invoices from '../views/Invoices/redux/InvoicesReducers';
import CustomerTouches from '../views/CustomerTouches/redux/CustomerTouchesReducers';
import Roles from '../views/Roles/redux/RolesReducers';
import Operators from '../views/Operators/redux/OperatorsReducers';
import FallingQuotes from '../views/FallingQuotes/redux/FallingQuotesReducers';
import Reasons from '../views/Reasons/redux/ReasonsReducers';
import Sales from '../views/Sales/redux/SalesReducers';
import StatusSales from '../views/StatusSales/redux/StatusSalesReducers';
import FranchiseReports from '../views/FranchiseReports/redux/FranchiseReportsReducers';
import FranchiseSummary from '../views/FranchiseSummary/redux/FranchiseSummaryReducers';
//import Stations from '../views/Stations/redux/StationsReducers'

export default combineReducers({
  Users,
  Clients,
  Franchises,
  Hotels,
  BillingInformationFranchises,
  BillingInformationClients,
  Quotations,
  Receipts,
  OperatorPayments,
  Comissions,
  Invoices,
  CustomerTouches,
  Roles,
  Operators,
  FallingQuotes,
  Reasons,
  Sales,
  StatusSales,
  FranchiseReports,
  FranchiseSummary
});



// WEBPACK FOOTER //
// ./src/store/reducers.js